import InputError from './InputError';
export default InputError;